import DataPoint from "../../../components/units/DataPoint/Membership";

export default function DataPointMembershipPage() {
  return <DataPoint />;
}
